/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
export function initQuorumValuesFromCodeDetails(source) {
    // Seed the base quorum to be an empty list with a code quorum set
    const committedCodeProposal = {
        key: "code",
        value: source,
        approvalSequenceNumber: 0,
        commitSequenceNumber: 0,
        sequenceNumber: 0,
    };
    return [["code", committedCodeProposal]];
}
//# sourceMappingURL=quorum.js.map